import React from "react";

export default ({ activeTab, handleClickTab, listCategory, onLoad }) => {
  const cursorStyle = {
    cursor: "pointer",
  };
  return (
    <div className="col-lg-3 col-md-12 col-sm-12 col-12 col-psre-1 d-lg-block d-md-none d-sm-none d-none">
      <ul className="navbar-nav nav-apa">
        <li className="nav-item ">
          <p
            className="nav-link"
            style={{ fontSize: "20px", fontWeight: "600" }}
          >
            Kategori Blog
          </p>
        </li>
        {onLoad ? (
          <li style={{ padding: '15px 50px'}}>Loading...</li>
        ) : (
          <>
            <li className="nav-item" style={cursorStyle}>
              <div
                className={
                  activeTab === "all"
                    ? `nav-link active item-hover`
                    : `nav-link item-hover`
                }
                onClick={() => handleClickTab("all")}
              >
                Semua Topik
              </div>
            </li>
            {listCategory.length
              ? listCategory.map((e, i) => {
                  return (
                    <li className="nav-item" style={cursorStyle} key={e._id}>
                      <div
                        className={
                          activeTab === e.categoryName
                            ? `nav-link active item-hover`
                            : `nav-link item-hover`
                        }
                        onClick={() => handleClickTab(e.categoryName)}
                      >
                        {e.categoryName}
                      </div>
                    </li>
                  );
                })
              : null}{" "}
          </>
        )}
      </ul>
    </div>
  );
};
